import { render, staticRenderFns } from "./ProductVideoForm.vue?vue&type=template&id=302afac4&"
import script from "./ProductVideoForm.vue?vue&type=script&lang=js&"
export * from "./ProductVideoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports